import useFetcher from 'app/_utils/data/useFetcher';

import { Workspace } from 'shared/src/generated/openapi/v2/types';
import useSWR from 'swr';

type UseGetWorkspaceParams = {
  organizationId: string | null | undefined;
  workspaceId: string | null | undefined;
};

export const useGetWorkspace = ({
  organizationId,
  workspaceId,
}: UseGetWorkspaceParams): ReturnType<typeof useSWR<Workspace, unknown>> => {
  const { fetcher } = useFetcher();

  const url =
    organizationId && workspaceId
      ? `${process.env.ZEUS_API_URL}/v2/organizations/${organizationId}/workspaces/${workspaceId}`
      : null;

  return useSWR<Workspace>(url, fetcher, { revalidateOnFocus: false });
};
